export const initialProgress = { questionNumber: 0, teamRound: 1 };

const ROUND_BY_STAGE = { TTR1: 1, TTR2: 2 };

// The server stamps every data-track event with the question it belongs to
// (1-based) and its stage (solo, TTR1, TTR2, solution_end), rejoins included.
export const questionOrderOf = (event) => {
  const order = Number(event?.question_order);
  return Number.isInteger(order) && order > 0 ? order : null;
};

// Question numbers only move forward: an event stamped with an earlier
// question (e.g. its analysis arriving after the next question started) is
// ignored. Within a question the round only moves forward too.
export const advanceProgress = (prev, event) => {
  const order = questionOrderOf(event);
  if (order !== null && order < prev.questionNumber) return prev;
  const questionNumber = order ?? prev.questionNumber;
  const stageRound = ROUND_BY_STAGE[event?.question_stage];
  const teamRound = questionNumber !== prev.questionNumber
    ? stageRound ?? 1
    : Math.max(stageRound ?? prev.teamRound, prev.teamRound);
  if (questionNumber === prev.questionNumber && teamRound === prev.teamRound) return prev;
  return { questionNumber, teamRound };
};

// A tip written at the end of question N is shown during N+1. Tips are keyed
// by N, so N+1's own tip, arriving while N+1 is on screen, doesn't replace it.
export const rememberTip = (tips, questionNumber, text) =>
  questionNumber ? { ...tips, [questionNumber]: text } : tips;

export const tipForQuestion = (tips, questionNumber) => tips[questionNumber - 1] ?? null;
